/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import scrollTo from "../functions/scrollTo";
import { useNavigate } from "react-router-dom";
import { Segment } from "semantic-ui-react";
import navigateToAnotherTerm from "./codeSystemResourceFunctions/navigateToAnotherTerm";
import { changeInitialScrolled, selectConceptCode, selectConceptPath, selectConceptPathIndexes,
     selectHasApprovalProperty, selectInitialScrolled } from "../slices/codeSystemTermDetail/codeSystemTermDetailSlice";
import { useDispatch, useSelector } from "react-redux";
import { selectEditMode } from "../slices/editMode/editModeSlice";

const bulletPoints = ['◉', '⦾', '■', '○', '♦', '◘', '•'];

let separatorCharacter = ": ";

const generatePathsLookup = (parentJson, parentPathString, dictionary) => {
    if (parentJson) {
        let separator = "";
        if (parentPathString) {
            separator = separatorCharacter;
        }

        for (let conceptIndex in parentJson.concept) {
            let concept = parentJson.concept[conceptIndex];
            if (concept?.display) {
                let pathString = parentPathString + separator + concept.display;
                if (concept.concept) {
                    dictionary[pathString] = { expanded: true };
                    generatePathsLookup(concept, pathString, dictionary);
                }
            }
        }
    }
    return dictionary;
};

const NavigationConcepts = ({ parentJson, level, parentPathString, parentPath, parentPathIndexes,
    resourceId, json,
    navigationCollapsedState, setNavigationCollapsedState, termToLinkDict, setTermToLinkDict
}) => {
    const hasApprovalProperty = useSelector(selectHasApprovalProperty);
    const conceptCode = useSelector(selectConceptCode);
    const editMode = useSelector(selectEditMode);

    let style = { paddingLeft: (level * 10).toString() + "px" };
    let separator = "";
    if (parentPathString) {
        separator = separatorCharacter;
    }

    return <>
        {parentJson?.concept?.map((concept, conceptIndex) => {
            let display = concept?.display || concept?.code;
            if (display) {
                let pathString = parentPathString + separator + display;
                let path = [...parentPath, display];
                let pathIndexes = [...parentPathIndexes, conceptIndex];

                let showAsDraft = false;
                if (hasApprovalProperty) {
                    showAsDraft = true;
                    for (let propertyIndex in concept.property) {
                        let property = concept.property[propertyIndex];
                        if (property?.valueString && property.code === "approval") {
                            showAsDraft = false;
                            break;
                        }
                    }
                }

                let linkStyle = {};
                if (concept && conceptCode === concept.code) {
                    linkStyle = { cursor: "default", color: "#000000", fontWeight: "bold" };
                }
                return <span key={conceptIndex} style={style}
                    id={concept && "termdetail-navigation-code-" + (concept.code || '')}>
                    {bulletPoints[level % bulletPoints.length]}
                    &nbsp;<a style={linkStyle}
                        className={editMode === true ? "disabled" : ""}
                        href={`/resources/CodeSystem/${resourceId}#${concept.code}`}
                        onClick={() => {
                            termToLinkDict[concept.code]();
                        }}>{display}</a>
                    {showAsDraft && <span style={{ fontSize: "11px" }}> (draft)</span>}
                    {(navigationCollapsedState[pathString] &&
                        navigationCollapsedState[pathString]["expanded"] !== undefined) &&
                        <span className={"unselectable"} style={{ cursor: "pointer" }}
                            onClick={() => {
                                setNavigationCollapsedState(prevState => {
                                    return {
                                        ...prevState,
                                        [pathString]: {
                                            ...prevState[pathString],
                                            "expanded": !prevState[pathString]["expanded"]
                                        }
                                    };
                                })
                            }} >&nbsp;{navigationCollapsedState[pathString]["expanded"] ? <>▼</> : <>►</>}
                        </span>
                    }
                    <br />
                    {(concept && navigationCollapsedState[pathString] &&
                        (navigationCollapsedState[pathString]["expanded"] === undefined ||
                            navigationCollapsedState[pathString]["expanded"] === true)) &&
                        <NavigationConcepts parentJson={concept} level={level + 1}
                            parentPathString={pathString}
                            parentPath={path} parentPathIndexes={pathIndexes}
                            resourceId={resourceId} json={json}
                            navigationCollapsedState={navigationCollapsedState}
                            setNavigationCollapsedState={setNavigationCollapsedState}
                            termToLinkDict={termToLinkDict} setTermToLinkDict={setTermToLinkDict}
                        />
                    }
                </span>
            } else {
                return <span key={conceptIndex}></span>
            }
        })}
    </>
};


const CollapseAllButton = ({ collapseAllState, setCollapseAllState, setNavigationCollapsedState }) => {
    return <>{collapseAllState === false && <span
        className={"unselectable"}
        style={{ cursor: "pointer" }}
        onClick={() => {
            setNavigationCollapsedState(prevState => {
                for (let key in prevState) {
                    prevState[key]["expanded"] = false;
                }
                return prevState;
            });
            setCollapseAllState(true);
        }}
    >
        ➖
    </span>}</>
};

const NavigationCodeSystemTermSegment = ({ resourceId, json,
    termToLinkDict, setTermToLinkDict }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const conceptCode = useSelector(selectConceptCode);
    const conceptPath = useSelector(selectConceptPath);
    const initialScrolled = useSelector(selectInitialScrolled);
    const conceptPathIndexes = useSelector(selectConceptPathIndexes);
    const editMode = useSelector(selectEditMode);

    useEffect(() => {
        if (initialScrolled !== true && editMode !== true) {
            let scrollToId = "termdetail-navigation-code-" + conceptCode;
            if (conceptPathIndexes?.length === 1 && parseInt(conceptPathIndexes[0]) === 0) {
                scrollToId = ""; //So it doesn't scroll for the top-most element
            }
            scrollTo("navigationTermDetailSegment", scrollToId, true);
            dispatch(changeInitialScrolled(true));
        }
    }, [initialScrolled, conceptCode, conceptPathIndexes, editMode]);

    const [navigationCollapsedState, setNavigationCollapsedState] = useState(generatePathsLookup(json, "", {}));
    const [collapseAllState, setCollapseAllState] = useState(false);

    return <Segment id={`navigationTermDetailSegment`}
        className={`containerSegment maxNavigationCodeSystemSegment`}
        style={{ marginTop: "8px", padding: "1px 4px 6px 4px" }} raised>
        <h2 className={"unselectable"}
            style={{
                fontSize: "20px", marginTop: "0px", marginBottom: "0px",
                textAlign: "center"
            }}>Term Navigation</h2>
        <div className={`navigationCodeSystemTermDetailSection`}
            style={{ paddingTop: "0px", textAlign: "left" }} >
            <span>
                {conceptPath?.length > 0 ?
                    <span
                        /* href={`/resources/CodeSystem/${resourceId}#TOP`} if it were an <a> tag*/
                        onClick={() => {
                            if (editMode === true) {
                                alert("Link not functional in edit mode");
                            } else {
                                navigateToAnotherTerm(dispatch, resourceId, {}, "", [], [], [], navigate);
                            }
                        }}>
                        <span><CollapseAllButton collapseAllState={collapseAllState}
                            setCollapseAllState={setCollapseAllState}
                            setNavigationCollapsedState={setNavigationCollapsedState} /> TOP</span>
                    </span>
                    :
                    <b><CollapseAllButton collapseAllState={collapseAllState}
                        setCollapseAllState={setCollapseAllState}
                        setNavigationCollapsedState={setNavigationCollapsedState} /> TOP</b>
                }
                <br />
            </span>
            {json && <NavigationConcepts parentJson={json} level={0}
                parentPathString={""} parentPath={[]} parentPathIndexes={[]}
                resourceId={resourceId} json={json}
                navigationCollapsedState={navigationCollapsedState}
                setNavigationCollapsedState={setNavigationCollapsedState}
                termToLinkDict={termToLinkDict} setTermToLinkDict={setTermToLinkDict} />}
        </div>
    </Segment>
}

export default NavigationCodeSystemTermSegment;